(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('occupationCrewsCtrl', occupationCrewsCtrl)
        .controller('occupationCrewNewCtrl', occupationCrewNewCtrl)
        .controller('occupationCrewEditCtrl', occupationCrewEditCtrl)
        .controller('occupationCrewDeleteCtrl', occupationCrewDeleteCtrl);

    occupationCrewsCtrl.$inject = ['linkService', 'occupationCrews', 'tabAdminFlights'];

    occupationCrewNewCtrl.$inject = ['linkService', 'tabAdminFlights', 'occupationCrewService'];

    occupationCrewEditCtrl.$inject = ['linkService', 'occupationCrew', 'tabAdminFlights','occupationCrewService'];

    occupationCrewDeleteCtrl.$inject = ['$uibModalInstance', 'occupationCrewService','$stateParams'];

    function occupationCrewsCtrl(linkService, occupationCrews, tabAdminFlights) {
        var vm = this;
        vm.pages = [];

        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.occupationCrews = (occupationCrews.data._embedded) ? occupationCrews.data._embedded.occupationCrews : [];
        vm.pages = occupationCrews.data.page;
    }

    function occupationCrewNewCtrl(linkService, tabAdminFlights, occupationCrewService) {
        var vm = this;
        vm.tabs = tabAdminFlights;
        vm.edit = false;
        vm.occupationCrew = {
            commandCrew: 0
        }

        vm.cancel = function () {
            linkService.reloadRoute('occupationCrews', null);
        }

        vm.saveOccupationCrew = function (isValid, occupationCrew) {
            if (isValid) {
                occupationCrewService.saveOccupationCrew(occupationCrew);
            }
        }
    }

    function occupationCrewEditCtrl(linkService, occupationCrew, tabAdminFlights,occupationCrewService){
        var vm = this;
        vm.occupationCrew = occupationCrew;
        vm.tabs = tabAdminFlights;
        vm.edit = true;
        vm.linkService = linkService;
        vm.old = angular.copy(vm.occupationCrew);
        vm.buttonSave = true;

        vm.cancel = function () {
            linkService.reloadRoute('occupationCrews', null);
        }

        vm.saveOccupationCrew = function (isValid, occupationCrew) {
            if (isValid) {
                occupationCrewService.updateOccupationCrew(vm.linkService.getLinkId(vm.occupationCrew._links.self.href),
                    occupationCrew);
            }
        }

        vm.change = function(){
            if( vm.occupationCrew.name.toUpperCase()==vm.old.name.toUpperCase() &&
                vm.occupationCrew.initials.toUpperCase()==vm.old.initials.toUpperCase() &&
                vm.occupationCrew.lang.toUpperCase()==vm.old.lang.toUpperCase()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function occupationCrewDeleteCtrl($uibModalInstance, occupationCrewService, $stateParams) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.deleteOccupationCrew = function () {
            occupationCrewService.deleteOccupationCrew($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }

})();
